/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, Stepper, Step, StepLabel, Button, Typography, CircularProgress } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';

/**
 * region for redux*/
import { connect } from 'react-redux';
import { MiniSitesActions } from '../../actions/MiniSitesActions';
import { withRouter } from "react-router-dom";

/**
 * region for styles*/
import { wizartSetupStyle } from './style/wizartSetupStyle';

/**
 * region for componets*/
import BasicDetails from '../../components/minisites/BasicDetails';
import SelectContent from '../../components/minisites/SelectContent';

/**
 * region for hepers*/
import typing from '../../helpers/typing';

/**
 * region for constans*/


class WizartSetup extends Component {

    state = {
        pending: false,
        modalOpen: true
    };
    
    componentDidMount() {
        const pending = this.props.pending;
        this.setState({ pending: pending });
        this.props.fetchMiniSiteClear();
        this.props.fetchMiniSiteGetBackOfficeUrl();
    }

    getSteps() {
        return ['Basic details', 'Select content'];
    }

    getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <BasicDetails />;
            case 1:
                return <SelectContent />;
            default:
                return 'Unknown step';
        }
    }

    handleNext() {
        let activeStep = this.props.activeStep;
        switch (activeStep) {
            case 0:
                let dataBasicDetails = this.props.dataBasicDetails;
                let errorName, errorSubdomain, errorDomain = false;
                if (typing.isEmpty(dataBasicDetails.name)) {
                    dataBasicDetails.errors.name = true;
                    errorName = true;
                } else {
                    dataBasicDetails.errors.name = false;
                    errorName = false;
                }

                if (typing.isEmpty(dataBasicDetails.subdomain)) {
                    dataBasicDetails.errors.subdomain = true;
                    errorSubdomain = true;
                } else {
                    if (!typing.isUrlFriendly(dataBasicDetails.subdomain)) {
                        dataBasicDetails.errors.subdomain = true;
                        errorSubdomain = true;
                    } else {
                        dataBasicDetails.errors.subdomain = false;
                        errorSubdomain = false;
                    }
                }

                if (typing.isEmpty(dataBasicDetails.domain)) {
                    dataBasicDetails.errors.domain = true;
                    errorDomain = true;
                } else {
                    dataBasicDetails.errors.domain = false;
                    errorDomain = false;
                }

                if (!errorName && !errorDomain && !errorSubdomain) {
                    let subdomain = dataBasicDetails.subdomain.concat(".").concat(dataBasicDetails.domain);
                    let dataRequest = {
                        subdomainCompare: subdomain
                    }
                    this.props.fetchMiniSiteGetIsValidSubdomain(dataRequest);
                } else {
                    this.props.fetchMiniSiteReloadComponet();
                }
                return;
            case 1:
                let dataSelectContent = this.props.dataSelectContent;
                if (dataSelectContent.selectListEvents.length === 0) {
                    dataSelectContent.errors.selectListEvents = true;
                    this.props.fetchMiniSiteReloadComponet();
                } else {
                    let dataBasicDetails = this.props.dataBasicDetails;
                    let subdomain = dataBasicDetails.subdomain.concat(".").concat(dataBasicDetails.domain);
                    const formData = new FormData();
                    formData.append('name', dataBasicDetails.name);
                    formData.append('domainName', subdomain);
                    formData.append('files', dataBasicDetails.minisiteLogo);

                    for (var i = 0; i < dataSelectContent.selectListEvents.length; i++) {
                        formData.append('selectListEvents', dataSelectContent.selectListEvents[i].id);
                    }
                    const { history } = this.props;
                    this.props.fetchMiniSiteSave(history,formData);
                }
                return;
            default:
                return 'Unknown step';
        }
    }

    handleBack() {
        let step = this.props.activeStep;
        let dataBasicDetails = this.props.dataBasicDetails;
        if (step > 0) {
            this.props.fetchMiniSiteSetActiveStep(step - 1, dataBasicDetails);
        }
    }

    handleClose() {
        this.setState({ modalOpen: false });
    };

    render() {
        const { classes } = this.props;
        const activeStep = this.props.activeStep;
        const pending = this.props.pending;
        const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
        const steps = this.getSteps();
        return (

            <Grid
                className={classes.contentAll}
                container
                spacing={0} >
                <Grid item xs={12} md={12} lg={12}>
                    {
                        <Paper className={fixedHeightPaper}>
                            <Grid container spacing={0}>
                                <Grid container item xs={12} spacing={0}>
                                    <div className={classes.root}>
                                        <Stepper activeStep={activeStep} alternativeLabel>
                                            {steps.map((label) => (
                                                <Step key={label}>
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                        <div className={classes.contentStep}>
                                            {activeStep === steps.length ? (
                                                <div >
                                                    <Typography className={classes.instructions}>All steps completed</Typography>
                                                    <Modal
                                                        open={this.state.modalOpen}
                                                        onClose={this.handleClose.bind(this)}
                                                        aria-labelledby="simple-modal-title"
                                                        aria-describedby="simple-modal-description">
                                                        <div style={{ position: 'fixed', top: '25%', left: '40%', transform: 'translate(-25%, -40%)%' }}
                                                            className={classes.modal}>
                                                            <h2>The Mini-site was saved</h2>
                                                        </div>
                                                    </Modal>

                                                </div>
                                            ) : (
                                                    <Fragment>
                                                        <Fragment>{this.getStepContent(activeStep)}</Fragment>
                                                        <Grid container
                                                            className={classes.footerStep}
                                                            direction="row"
                                                            justify="flex-end"
                                                            alignItems="center" spacing={1}>
                                                            <Grid item>
                                                                {
                                                                    pending && <CircularProgress size={24} />
                                                                }
                                                                {activeStep !== 0 &&
                                                                    <Button onClick={this.handleBack.bind(this)} className={classes.backButton}>
                                                                        Back
                                                                </Button>
                                                                }
                                                                <Button variant="contained" color="primary" onClick={this.handleNext.bind(this)}>
                                                                    {activeStep === steps.length - 1 ? 'Save' : 'Next'}
                                                                </Button>
                                                            </Grid>

                                                        </Grid>
                                                    </Fragment>
                                                )}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                    }
                </Grid>
            </Grid >
        );
    }
}
WizartSetup.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const dataBasicDetails = state.MiniSitesReducers.dataBasicDetails;
    const dataSelectContent = state.MiniSitesReducers.dataSelectContent;
    const activeStep = state.MiniSitesReducers.activeStep;
    const pending = state.MiniSitesReducers.pending;

    return {
        dataBasicDetails,
        dataSelectContent,
        activeStep,
        pending
    };
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMiniSiteGetIsValidSubdomain: (subdomain) => dispatch(MiniSitesActions.fetchMiniSiteGetIsValidSubdomain(subdomain)),
        fetchMiniSiteSetAttributes: (attributes) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributes(attributes)),
        fetchMiniSiteSetAttributesSelectListEvents: (dataSelectContent) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributesSelectListEvents(dataSelectContent)),
        fetchMiniSiteSetActiveStep: (activeStep, dataBasicDetails) => dispatch(MiniSitesActions.fetchMiniSiteSetActiveStep(activeStep, dataBasicDetails)),
        fetchMiniSiteSave: (history,data) => dispatch(MiniSitesActions.fetchMiniSiteSave(history,data)),
        fetchMiniSiteGetBackOfficeUrl: () => dispatch(MiniSitesActions.fetchMiniSiteGetBackOfficeUrl()),
        fetchMiniSiteReloadComponet: () => dispatch(MiniSitesActions.fetchMiniSiteReloadComponet()),
        fetchMiniSiteClear: () => dispatch(MiniSitesActions.fetchMiniSiteClear())

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(wizartSetupStyle)(withRouter(WizartSetup)));